import type { CmsShortcutItem } from '@nsftx/seven-client-retail-vue-sgp'
import type { AppShortcutCategory, ShortcutCategory, ShortcutCategoryItem } from './shortcutsTypes'

const SHORTCUT_CATEGORIES: AppShortcutCategory[] = [
  'general',
  'system',
  'modal',
  'notification',
  'game',
  'products'
]

const getShortcutKeys = (shortcutItem: CmsShortcutItem) => [
  ...(shortcutItem.modifier ?? []).map(
    (modifier) => modifier.charAt(0).toUpperCase() + modifier.slice(1),
  ),
  ...(shortcutItem.key
    ? [shortcutItem.key.charAt(0).toUpperCase() + shortcutItem.key.slice(1)]
    : []),
]

const mapToShortcutCategoryItems = <
  T extends { order: number; label?: string; shortcut: CmsShortcutItem[] },
>(
  shortcuts: T[],
): ShortcutCategoryItem[] =>
  shortcuts
    .sort((a, b) => a.order - b.order)
    .map((shortcut) => ({
      label: shortcut.label ?? '-',
      keys: shortcut.shortcut[0] ? getShortcutKeys(shortcut.shortcut[0]) : [],
    }))

const createShortcutCategoryRecord = (): ShortcutCategory => ({
  general: [],
  system: [],
  modal: [],
  notification: [],
  game: [],
  products: [],
})

export {
  SHORTCUT_CATEGORIES,
  getShortcutKeys,
  mapToShortcutCategoryItems,
  createShortcutCategoryRecord,
}
